import purpleTheme from './purpleTheme';
import NdsThemeProviderBaseHoc from './NdsThemeProviderBaseHoc';
const NdsThemeProviderPurple = NdsThemeProviderBaseHoc(purpleTheme);
export { NdsThemeProviderPurple as NdsThemeProviderRootComp };
export default NdsThemeProviderPurple;
//# sourceMappingURL=NdsThemeProviderPurple.js.map